import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type { PartnersProductsInterface } from '~/src/repositories/cms/entities/partners/types/cms.partners.types';

export const getMappedPartnersData = (data: DictionaryInterface[]): PartnersProductsInterface[][] => {
    return data?.map((item) => {
        return item?.articles
            .map((elem) => {
                if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                    return {
                        title: elem?.attributeCategories?.produkt?.attributes?.nazvaniye_produkta?.value || '',
                        logo: elem?.attributeCategories?.produkt?.attributes?.logo?.value || '',
                        bodyText: elem?.attributeCategories?.produkt?.attributes?.opisaniye_produkta?.value || '',
                        link: elem?.attributeCategories?.produkt?.attributes?.ssylka_na_produkt?.value || '',
                        label: elem?.attributeCategories?.produkt?.attributes?.dop_tekst_v_leyble?.value || '',
                        type: elem?.attributeCategories?.produkt?.attributes?.napravleniye_produkta?.value?.code || '',
                        order: elem?.order,
                        adLabel: elem?.attributeCategories?.produkt?.attributes?.metka_reklamy?.value || '',
                    };
                }
                return { title: '', logo: '', bodyText: '', link: '', label: '', type: '', order: fallBackOrder };
            })
            .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
    });
};
